import { render } from "./LoadingSpinner.vue?vue&type=template&id=a0f8adb6"
const script = {}

import "./LoadingSpinner.vue?vue&type=style&index=0&id=a0f8adb6&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__